/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';

import { IToken } from './token';

export interface IMedia {
  token: IToken;
  labels: boolean;
  inDetailView?: boolean;
  square?: boolean;
  children?: ReactNode;
  allowsExplicit?: boolean;
  allowsPhotosensitive?: boolean;
}

export interface IMediaOptions {
  posterFrame?: number;
  posterTime?: number;
  posterLastFrame?: boolean;
  previewStartTime?: number;
  previewEndTime?: number;
  generateFullLength?: boolean;
  preserveAlpha?: boolean;
  skipVideo?: boolean;
}

export interface IMediaMetadata {
  width?: number;
  height?: number;
  aspect?: string;
  duration?: number;
}

export interface IMediaItem {
  file: File;
  meta: IMediaMetadata;
}

export const instanceOfIMediaItem = (object: any): object is IMediaItem => {
  return 'file' in object && 'meta' in object;
};

export interface IWebDirectoryItem {
  files: Record<string, File>;
  name: string;
  meta: IMediaMetadata;
}

export interface IMediaRequest {
  url: string;
  name: string;
}

export interface IProgressCallbackEvent {
  ratio: number;
  current?: number;
  total?: number;
}

export interface IProgressCallback {
  (event: IProgressCallbackEvent): void;
}

export interface IUploadImage {
  blob: string;
  ipfs: string;
}
